import { api } from "../../lib";

// Backend uses PracticeReportDeliveryMethod entity with practiceId
// Frontend uses "account" naming for backwards compatibility
export interface AccountReportDelivery {
  id: string;
  practiceId: string; // Maps to practice_id in DB
  reportDeliveryMethodId: string;
  email: string | null;
  phone: string | null;
  fax: string | null;
  address: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  practice?: { name: string } | null; // Renamed from account
  reportDeliveryMethod?: { name: string } | null;
  remoteConnectionIdentifier?: string | null;
}

export interface CreateAccountReportDeliveryInput {
  practiceId: string;
  reportDeliveryMethodId: string;
  email?: string | null;
  phone?: string | null;
  fax?: string | null;
  address?: string | null;
  isActive?: boolean;
  remoteConnectionIdentifier?: string | null;
  physicianId?: string | null;
}

export interface UpdateAccountReportDeliveryInput
  extends Partial<CreateAccountReportDeliveryInput> {
  id: string;
}

export const accountReportDeliveryService = {
  getAll: async () => {
    return api.get<AccountReportDelivery[]>("/admin/account-report-delivery");
  },

  getById: async (id: string) => {
    return api.get<AccountReportDelivery>(
      `/admin/account-report-delivery/${id}`
    );
  },

  create: async (input: CreateAccountReportDeliveryInput) => {
    return api.post<AccountReportDelivery>(
      "/admin/account-report-delivery",
      input
    );
  },

  update: async (input: UpdateAccountReportDeliveryInput) => {
    const { id, ...updates } = input;
    return api.put<AccountReportDelivery>(
      `/admin/account-report-delivery/${id}`,
      updates
    );
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.patch<AccountReportDelivery>(
      `/admin/account-report-delivery/${id}/toggle-active`,
      { isActive }
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/account-report-delivery/${id}`);
  },
};
